export default function ContactSection() {
  return (
    <section id="contact" className="py-14 md:py-20 bg-background-50">
      <div className="w-full px-4 md:px-6 max-w-[1280px] mx-auto">
        <div className="max-w-[720px] mx-auto text-center">
          <div className="w-16 h-16 mx-auto mb-5 flex items-center justify-center rounded-full bg-primary-100">
            <i className="ri-mail-send-line text-2xl text-primary-500"></i>
          </div>
          <h2 className="text-2xl md:text-3xl font-heading text-foreground-950 mb-3">投稿爆料</h2>
          <p className="text-foreground-500 text-sm md:text-base leading-relaxed mb-8">
            你有第一手网红八卦黑料？发现某位主播的不为人知的秘密？
            欢迎通过下方表单向我们投稿。我们承诺对爆料人信息严格保密，优质线索一经采用即付稿酬。
          </p>

          <form
            data-readdy-form
            action="https://readdy.ai/api/form/d9kvhp0h9dsfbuoi6kvg"
            method="POST"
            className="bg-background-100 rounded-lg p-6 md:p-8 border border-background-200/60 text-left"
          >
            <div className="grid grid-cols-1 sm:grid-cols-2 gap-4 mb-4">
              <div>
                <label className="block text-sm text-foreground-600 mb-1.5">你的昵称</label>
                <input type="text" name="nickname" className="w-full px-3 py-2.5 bg-background-50 border border-background-300 rounded-md text-sm text-foreground-900 outline-none focus:border-primary-300 transition-colors" placeholder="怎么称呼你？" />
              </div>
              <div>
                <label className="block text-sm text-foreground-600 mb-1.5">联系方式</label>
                <input type="email" name="email" className="w-full px-3 py-2.5 bg-background-50 border border-background-300 rounded-md text-sm text-foreground-900 outline-none focus:border-primary-300 transition-colors" placeholder="用于回复，选填" />
              </div>
            </div>
            <div className="mb-4">
              <label className="block text-sm text-foreground-600 mb-1.5">爆料主题</label>
              <input type="text" name="subject" className="w-full px-3 py-2.5 bg-background-50 border border-background-300 rounded-md text-sm text-foreground-900 outline-none focus:border-primary-300 transition-colors" placeholder="一句话概括你要爆的料" />
            </div>
            <div className="mb-2">
              <label className="block text-sm text-foreground-600 mb-1.5">详细内容 <span className="text-foreground-400 text-xs">（最多500字）</span></label>
              <textarea name="content" rows={5} maxLength={500} className="w-full px-3 py-2.5 bg-background-50 border border-background-300 rounded-md text-sm text-foreground-900 outline-none focus:border-primary-300 transition-colors resize-none" placeholder="请详细描述你掌握的信息，包括时间、人物、事件经过和相关证据线索..."></textarea>
            </div>
            <div className="form-honeypot">
              <input type="text" name="phone_alt" tabIndex={-1} autoComplete="off" aria-hidden="true" readOnly />
            </div>
            <div className="flex items-center justify-between mt-5">
              <p className="text-xs text-foreground-400">提交即表示你确认所提供信息真实有效</p>
              <button type="submit" className="px-6 py-2.5 bg-primary-500 text-background-50 rounded-md text-sm font-medium hover:bg-primary-600 transition-colors whitespace-nowrap cursor-pointer">
                <i className="ri-send-plane-line mr-1.5"></i>提交爆料
              </button>
            </div>
          </form>
        </div>
      </div>
    </section>
  );
}